<div class="sections" *ngIf="!loading">

    <div class="step-summaries">
        <div class="step-info">
            <div class="title">
                <h3>Documents</h3>
                <app-icon class="se-icon-button" src="edit2" width="24px" height="24px" (click)="goToStep.emit(0)"></app-icon>
            </div>
            <div class="files">
                <div class="file" *ngFor="let documentType of fileKeys" (click)="viewFile(documentType)"
                     [matTooltip]="typeName[documentType] + '\n' + files[documentType]!.name"
                >
                    <ng-container [ngTemplateOutlet]="fileImg" [ngTemplateOutletContext]="{ text: fileExt(files[documentType]!.mimeType) }"></ng-container>
                </div>
            </div>
        </div>

        <div class="step-info">
            <ng-container [ngTemplateOutlet]="step" [ngTemplateOutletContext]="{ step: legalStep, index: 1 }"></ng-container>
        </div>

        <div class="step-info">
            <ng-container [ngTemplateOutlet]="step" [ngTemplateOutletContext]="{ step: dbaStep, index: 2 }"></ng-container>
        </div>
        <div class="step-info">
            <ng-container [ngTemplateOutlet]="step" [ngTemplateOutletContext]="{ step: additionalBusinessInfoStep, index: 3 }"></ng-container>
        </div>
        <div class="step-info">
            <ng-container [ngTemplateOutlet]="step" [ngTemplateOutletContext]="{ step: salesProfileStep, index: 4 }"></ng-container>
        </div>
        <div class="step-info">
            <div class="title">
                <h3>{{ businessOwnersStep.title }}</h3>
                <app-icon class="se-icon-button" src="edit2" width="24px" height="24px" (click)="goToStep.emit(5)"></app-icon>
            </div>
            <div class="field-group" *ngFor="let fields of businessOwnersStep.fields let i = index" [class.open]="i === openedOwner" (click)="ownerGroupClick(i)">
                <div class="arrow" *ngIf="businessOwnersStep.fields.length > 1">
                    <mat-icon matSuffix class="rotate" [class.do]="i === openedOwner">expand_more</mat-icon>
                </div>
                <h3 *ngIf="i !== openedOwner" class="name">{{ fields[0].value }}</h3>
                <div class="values">
                    <div class="field" *ngFor="let field of fields">
                        <h4>{{ field.name }}:</h4>
                        <ng-container [ngSwitch]="field.type">
                            <p *ngSwitchCase="undefined">{{ field.value }}</p>
                            <p *ngSwitchCase="'phone'">{{ field.value | mask: '(000) 000-0000'}}</p>
                            <p *ngSwitchCase="'$'">${{ field.value | mask: 'separator.0': { thousandSeparator: ',' } }}</p>
                            <p *ngSwitchCase="'%'">{{ field.value | mask: 'separator.0': { thousandSeparator: ',' } }}%</p>
                        </ng-container>
                    </div>
                </div>
            </div>
        </div>

        <div class="step-info">
            <ng-container [ngTemplateOutlet]="step" [ngTemplateOutletContext]="{ step: bankInformationStep, index: 6 }"></ng-container>
        </div>

        <div>
            <div class="signature">
                <div class="form-checkbox w-100">
                    <mat-checkbox [formControl]="submitCheckboxControl" color="primary" (change)="signatureApprovalClick($event)"></mat-checkbox>
                    <p>I agree to sign the document digitally</p>
                </div>
                <div [class]="'signature-frame ' + (!currentSignatures.owner ? 'open' : 'signed')" [class.disabled]="signatureApproval === undefined"
                     (click)="openSignatureModal()"
                >
                    <div class="add-signature" *ngIf="!currentSignatures.owner && !waitingForSignatureApproval">Add signature</div>
                    <mat-progress-spinner mode="indeterminate" diameter="24" *ngIf="waitingForSignatureApproval"></mat-progress-spinner>
                    <img *ngIf="currentSignatures.owner" [src]="currentSignatures.owner.downloadUrl" alt="signature">
                </div>
                <div class="signer" *ngIf="!currentSignatures.owner">
                    {{ userName }}
                </div>
                <div class="signer" *ngIf="currentSignatures.owner">
                    Signed by:&nbsp;{{ currentSignatures.owner.signerName }}, &nbsp;{{ currentSignatures.owner.timestamp | date: 'dd MMM, YYYY' }}
                </div>
            </div>
            <div class="actions">
                <loader-button
                        *ngIf="!currentSignatures.owner?.submitted"
                        [loading]="uploadingSignature"
                        [disabled]="!currentSignatures.owner"
                        [text]="ownerIsGuarantor ? 'Preview' : 'Send'"
                        (onClick)="onSubmitClick()"
                ></loader-button>
                <loader-button
                        *ngIf="currentSignatures.owner?.submitted"
                        [loading]="uploadingSignature"
                        [disabled]="!currentSignatures.owner"
                        text="Preview"
                        (onClick)="goToStep.emit(8)"
                ></loader-button>
            </div>
        </div>
    </div>
    <div class="divider"></div>
    <div>
        <div class="info">
            <div class="background"></div>
            <p>
                Incorrect or incomplete information could cause delays in processing, verification issues, or payment disruptions. Ensuring accuracy now helps prevent complications later.
            </p>
            <div class="note" *ngIf="!ownerIsGuarantor">
                <p>Note: Sign the document, then click 'Send' to forward it to the guarantor (<span style="color:black;">{{guarantorEmail}}</span>) for their signature.<br>Once they sign, you will receive an email notification to complete and submit the document.</p>
            </div>
            <p *ngIf="ownerIsGuarantor">
                Click the 'Preview' button to generate the document and view it before submitting the application.
            </p>
        </div>
    </div>
</div>

<ng-template #step let-step="step" let-index="index">
    <div class="title">
        <h3>{{ step.title }}</h3>
        <app-icon class="se-icon-button" src="edit2" width="24px" height="24px" (click)="goToStep.emit(index)"></app-icon>
    </div>
    <ng-container *ngIf="!step.type">
        <div class="field" *ngFor="let field of step.fields">
            <h4>{{ field.name }}:</h4>
            <ng-container [ngSwitch]="field.type">
                <p *ngSwitchCase="undefined">{{ field.value }}</p>
                <p *ngSwitchCase="'phone'">{{ field.value | mask: '(000) 000-0000'}}</p>
                <p *ngSwitchCase="'$'">${{ field.value | mask: 'separator.0': { thousandSeparator: ',' } }}</p>
                <p *ngSwitchCase="'%'">{{ field.value | mask: 'separator.0': { thousandSeparator: ',' } }}%</p>
            </ng-container>
        </div>
    </ng-container>
</ng-template>

<ng-template #fileImg let-text="text">
    <svg width="36" height="36" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_402_2599)">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M3 0C2.44772 0 2 0.447716 2 1V23C2 23.5523 2.44772 24 3 24H21C21.5523 24 22 23.5523 22 23V4L18 0H3Z" fill="#E9F0FA"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M18 0V4H22L18 0Z" fill="#C2CDDE"/>
        </g>
        <rect x="1" y="10" width="22" height="10" rx="1" fill="#4881F1"/>
        <text x="12" y="17.5" fill="white" text-anchor="middle" font-family="Arial" font-size="6" font-weight="bold">{{text}}</text>
        <defs>
            <clipPath id="clip0_402_2599">
                <rect width="20" height="24" fill="white" transform="translate(2)"/>
            </clipPath>
        </defs>
    </svg>
</ng-template>

<div class="file-view" *ngIf="viewFileURL">
    <div class="view-file-content-wrapper">
        <iframe *ngIf="viewFileType !== 'img'" [class.txt]="viewFileType === 'txt'" [src]="viewFileURL" class="flex-fill view-file-content" frameborder="0"
                width="100%"
        ></iframe>
        <img *ngIf="viewFileType === 'img'" class="flex-fill view-file-content" [src]="viewFileURL">
        <app-icon width="40px" height="40px" class="se-icon-button close-button" src="close" (click)="viewFileURL = null;"></app-icon>
    </div>
</div>